import { makeStyles } from "@material-ui/core";

export const brandTeal = "#009CA7";
export const brandTealLight = "#E5F5F6";

export const useDashboardStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        overflowX: "auto",
    },
    table: {
        minWidth: 650,
        border: "none",
        [theme.breakpoints.down("sm")]: {
            overflowX: "scroll",
        },
    },
    tableContainer: {
        borderSpacing: "15px",
    },
    tableRow: {
        borderBottom: "none",
    },
    bold: {
        fontWeight: "bold",
    },
    editIcon: {
        color: "gray",
    },
    stickyHeader: {
        backgroundColor: `${brandTealLight} !important`,
        fontWeight: 700,
    },
    photoChipLabel: {
        whiteSpace: "nowrap",
        display: "block",
        margin: "0 auto",
    },
    photoChipContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
    },
    photoChip: {
        backgroundColor: `${brandTealLight} !important`,
        color: `${brandTeal} !important`,
        border: `1px solid ${brandTeal} !important`,
        fontWeight: 600,
        '&:hover': {
            backgroundColor: '#D6EFEF !important',
        }
    }
}));

export const photoDialoguePaperSx = {
    width: 500,
    maxWidth: '95vw',
    maxHeight: 'calc(100vh - 80px)',
    margin: 0,
    borderRadius: '12px',
    border: `2px solid ${brandTeal}`,
    boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
} as const;

export const photoDialogueBackdropSx = {
    backgroundColor: 'rgba(0,0,0,0.45)',
} as const;

export const usePhotoDialogueStyles = makeStyles(() => ({
    dialogBody: {
        padding: '18px 20px 0 20px',
        overflowY: 'auto',
    },
    title: {
        margin: '0 0 14px 0',
        fontSize: 17,
        fontWeight: 700,
        color: '#1a1a1a',
    },
    dateRangeSection: {
        marginBottom: 12,
    },
    sectionLabel: {
        display: 'block',
        fontWeight: 600,
        fontSize: 12,
        color: '#333',
        marginBottom: 6,
    },
    inlineLabel: {
        fontWeight: 600,
        fontSize: 12,
        color: '#333',
    },
    visitIdSection: {
        marginBottom: 6,
    },
    visitIdHeaderRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 6,
    },
    visitBadge: {
        marginLeft: "auto",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#E9EBF2",
        color: "#68738D",

        fontSize: 14,
        fontWeight: 500,

        padding: '2px 8px',
        borderRadius: 6,

        whiteSpace: "nowrap",
    },
    visitBadgeSelected: {
        marginLeft: "auto",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#E3F2FD",
        color: "#1976D2",

        fontSize: 14,
        fontWeight: 500,

        padding: '2px 8px',
        borderRadius: 6,

        whiteSpace: "nowrap",
    },
    visitBadgeError: {
        marginLeft: "auto",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#FDECEA",
        color: "#D32F2F",

        fontSize: 14,
        fontWeight: 500,

        padding: '2px 8px',
        borderRadius: 6,

        whiteSpace: "nowrap",
    },
    loadingText: {
        fontSize: 13,
        color: '#888',
        padding: '8px 0',
    },
    spacer: {
        height: 10,
    },
    footer: {
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'center',
        gap: 12,
        padding: '12px 20px 14px',
        borderTop: '1px solid #f0f0f0',
        background: '#fff',
        borderRadius: '0 0 10px 10px',
    },
    actionButtonBase: {
        padding: '7px 28px',
        borderRadius: 6,
        fontSize: 13,
        fontWeight: 600,
        cursor: 'pointer',
    },
    cancelButton: {
        border: '1px solid #ccc',
        background: '#fff',
        color: '#333',
    },
    downloadButtonBase: {
        border: 'none',
        color: '#fff',
        transition: 'background 0.2s',
    },
    downloadButtonEnabled: {
        background: brandTeal,
        cursor: 'pointer',
    },
    downloadButtonDisabled: {
        background: '#b0bec5',
        cursor: 'not-allowed',
    },
    gtPhotoMultiselect: {
        '& .dropdown-content': {
            position: 'static !important',
            boxShadow: 'none !important',
            border: '1px solid #e0e0e0 !important',
            borderTop: 'none !important',
            borderRadius: '0 0 4px 4px !important',
        },
        '& .dropdown-heading': {
            border: '1px solid #ccc !important',
            borderRadius: '4px !important',
            height: '34px !important',
            background: '#fff !important',
            fontSize: '12px !important',
        },
        '& .rmsc .options': {
            maxHeight: '150px !important',
            overflowY: 'auto !important',
            position: 'relative',
        },
        '& .rmsc .options > .select-item:first-child': {
            position: 'sticky !important',
            top: 0,
            zIndex: 1,
            backgroundColor: '#fff',
        },
        '& .rmsc .item-renderer': {
            fontSize: '12px !important',
        },
        '& .rmsc .search input': {
            fontSize: '12px !important',
        },
    },
}));
